import React from "react";

const StoryboardContext = React.createContext({
  storyboard: null
});

export default StoryboardContext;